import { render, staticRenderFns } from "./EasypayCheckout.vue?vue&type=template&id=ddda0356&scoped=true"
import script from "./EasypayCheckout.vue?vue&type=script&lang=js"
export * from "./EasypayCheckout.vue?vue&type=script&lang=js"
import style0 from "./EasypayCheckout.vue?vue&type=style&index=0&id=ddda0356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddda0356",
  null
  
)

export default component.exports